import * as SentryModule from "@sentry/react";

// Determine environment from NODE_ENV or ENV (fallback)
const env = process.env.NODE_ENV || process.env.ENV || 'local';
const isLocal = env === 'local' || env === 'dev-local';

let Sentry;

// Initialize Sentry in development and production (but NOT in local)
if (!isLocal) {
  const isProduction = env === 'production' || env === 'prod';
  const isDevelopment = env === 'development' || env === 'dev';
  
  SentryModule.init({
    dsn: "https://2e5cef8b2871180acc2da99b3be1577f@o4509778952978432.ingest.us.sentry.io/4509778958745600",
    integrations: [
      SentryModule.browserTracingIntegration(),
    ],
    tracesSampleRate: isProduction ? 0.1 : 1.0, // Lower sample rate in production
    environment: isProduction ? 'production' : (isDevelopment ? 'development' : env),
    
    // Enhanced breadcrumb configuration
    maxBreadcrumbs: 50, // Increase breadcrumb limit for better context
    beforeBreadcrumb(breadcrumb, hint) {
      // Filter out sensitive data from breadcrumbs
      if (breadcrumb.data) {
        // Remove sensitive fields
        const sensitiveFields = ['password', 'token', 'authorization', 'cookie', 'secret'];
        sensitiveFields.forEach(field => {
          if (breadcrumb.data[field]) {
            breadcrumb.data[field] = '[REDACTED]';
          }
        });
      }
      return breadcrumb;
    },
    
    // Enhanced error context
    beforeSend(event, hint) {
      // Add additional context to errors
      if (event.exception) {
        event.tags = {
          ...event.tags,
          client: true,
          userAgent: navigator.userAgent,
          url: window.location.href,
        };
      }
      return event;
    },
  });
  
  Sentry = SentryModule;
} else {
  // In local mode, create a no-op Sentry object (only console logs)
  Sentry = {
    captureMessage: () => {},
    captureException: () => {},
    addBreadcrumb: () => {},
  };
}

export default Sentry;